module.exports = {
  // Specify the element to use as a container, string (query) or HTMLElement
  // With the empty value, nothing will be rendered
  appendTo: '',

  blocks: [],

  data: {
    position: '',
    top: '',
    bottom: '',
    left: '',
    right: ''
  }
};
